import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Stack,
  Card,
  TextInput,
  PasswordInput,
  Checkbox,
  Center,
  Divider
} from '@mantine/core';
import { IconArrowLeft, IconUserPlus, IconLogin } from '@tabler/icons-react';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    agreeTerms: false
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Redirect to identity verification after registration
    navigate('/verify-identity');
  };

  return (
    <Container size="sm" py="xl">
      <Stack gap="xl">
        <Group justify="space-between" align="center">
          <Button 
            component={Link} 
            to="/" 
            variant="subtle" 
            leftSection={<IconArrowLeft size="1rem" />}
          >
            Back to Home
          </Button>
        </Group>

        <Center>
          <Stack gap="md" align="center" maw={400}>
            <IconUserPlus size={48} color="var(--mantine-color-grape-6)" />
            <Title order={1} ta="center">
              Create New Account
            </Title>
            <Text size="lg" ta="center" c="dimmed">
              Join the PediPiggy community!
            </Text>
          </Stack>
        </Center>

        <Card shadow="md" padding="xl" radius="md" withBorder>
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Username"
                placeholder="Choose a username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <TextInput
                label="Email"
                placeholder="your@email.com"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <PasswordInput
                label="Password"
                placeholder="Create a password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <PasswordInput
                label="Confirm Password"
                placeholder="Confirm your password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <Checkbox
                label="I agree to the Terms of Service and Privacy Policy"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                required
              />
              <Button 
                type="submit" 
                fullWidth 
                size="lg" 
                color="grape"
                mt="md"
              >
                Create Account
              </Button>
            </Stack>
          </form>
        </Card>

        <Center>
          <Text c="dimmed">
            Already have an account?{' '}
            <Text component={Link} to="/login" c="grape" fw={500} style={{ textDecoration: 'none' }}>
              Log in Here
            </Text>
          </Text>
        </Center>
      </Stack>
    </Container>
  );
};

export default RegisterPage;